export const IMAGES = {
  hero: {
    local: "/assets/img/hero-tarmac.png",
    fallback: "https://images.unsplash.com/photo-1542296332-2e4473faf563?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxhaXJwb3J0JTIwZ3JvdW5kJTIwaGFuZGxpbmclMjBjYXJnb3xlbnwwfHx8fDE3OTA1MjgyNzd8MA&ixlib=rb-4.1.0&q=85",
  },
  ground: {
    local: "/assets/img/ground-ops.png",
    fallback: "https://images.unsplash.com/photo-1713763169644-aa6c4d221d72?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHw0fHxhaXJwb3J0JTIwZ3JvdW5kJTIwaGFuZGxpbmclMjBjYXJnb3xlbnwwfHx8fDE3OTA1MjgyNzd8MA&ixlib=rb-4.1.0&q=85",
  },
  cargo: {
    local: "/assets/img/cargo.png",
    fallback: "https://images.unsplash.com/photo-1571086291540-b137111fa1c7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwyfHxhaXJwb3J0JTIwZ3JvdW5kJTIwaGFuZGxpbmclMjBjYXJnb3xlbnwwfHx8fDE3OTA1MjgyNzd8MA&ixlib=rb-4.1.0&q=85",
  },
  vip: {
    local: "/assets/img/vip-jet.png",
    fallback: "https://images.unsplash.com/photo-1474302770737-173ee21bab63?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHxwcml2YXRlJTIwamV0JTIwbHV4dXJ5fGVufDB8fHx8MTc5MDUyODI3N3ww&ixlib=rb-4.1.0&q=85",
  },
  catering: {
    local: "/assets/img/catering.png",
    fallback: "https://images.unsplash.com/photo-1661954864180-e61dea14208a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwzfHxwcml2YXRlJTIwamV0JTIwbHV4dXJ5fGVufDB8fHx8MTc5MDUyODI3N3ww&ixlib=rb-4.1.0&q=85",
  },
  apron: {
    local: "/assets/img/apron-aerial.png",
    fallback: "https://images.unsplash.com/photo-1628354219577-1059383b3929?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwyfHxhaXJwbGFuZSUyMHRhcm1hY3xlbnwwfHx8fDE3OTA1MjgyNzd8MA&ixlib=rb-4.1.0&q=85",
  },
};

export const CONTACT = {
  opsEmail: "ops@world-was.ly",
  ceoEmail: "ceo@world-was.ly",
  phoneDisplay: "+218 92 305 1445",
  phoneRaw: "+218923051445",
  whatsapp: "https://wa.me/218923051445",
};

export const AIRPORTS = [
  {
    code: "MJI", icao: "HLLM", isHq: true, x: 32, y: 26,
    name_ar: "مطار معيتيقة الدولي", name_en: "Mitiga International Airport",
    city_ar: "طرابلس — المقر الرئيسي", city_en: "Tripoli — Headquarters",
    type_ar: "المركز الرئيسي للعمليات", type_en: "Primary Operations Hub",
    status_ar: "عمليات 24/7", status_en: "24/7 Operations",
    runway: "3,400 m",
    services_ar: ["مناولة أرضية متكاملة", "صالة كبار الشخصيات", "وقود Jet A-1", "تصاريح عبور وهبوط", "مركز عمليات 24/7", "شحن جوي"],
    services_en: ["Full Ground Handling", "VIP Terminal", "Jet A-1 Fueling", "Overflight/Landing Permits", "24/7 OCC", "Cargo"],
  },
  {
    code: "BEN", icao: "HLLB", x: 66, y: 30,
    name_ar: "مطار بنينا الدولي", name_en: "Benina International Airport",
    city_ar: "بنغازي", city_en: "Benghazi",
    type_ar: "بوابة الشرق الليبي", type_en: "Eastern Gateway Hub",
    status_ar: "عمليات 24/7", status_en: "24/7 Operations",
    runway: "3,576 m",
    services_ar: ["مناولة ساحة كاملة", "تنسيق وقود", "إرسال جوي", "نقل أطقم"],
    services_en: ["Full Ramp Handling", "Fuel Arrangement", "Flight Dispatch", "Crew Transport"],
  },
  {
    code: "MRA", icao: "HLMS", x: 42, y: 30,
    name_ar: "مطار مصراتة الدولي", name_en: "Misrata International Airport",
    city_ar: "مصراتة", city_en: "Misrata",
    type_ar: "مركز تجاري وصناعي", type_en: "Commercial & Industrial Hub",
    status_ar: "تشغيلي", status_en: "Operational",
    runway: "3,400 m",
    services_ar: ["مناولة شحن", "خدمات ركاب", "خانات هبوط وتصاريح"],
    services_en: ["Cargo Handling", "Passenger Handling", "Clearance & Slots"],
  },
  {
    code: "SEB", icao: "HLLS", x: 38, y: 66,
    name_ar: "مطار سبها الدولي", name_en: "Sebha International Airport",
    city_ar: "سبها — الجنوب الليبي", city_en: "Sebha — Southern Hub",
    type_ar: "بوابة الجنوب", type_en: "Southern Sector Gateway",
    status_ar: "تشغيل عند الطلب", status_en: "On Request",
    runway: "3,599 m",
    services_ar: ["تنسيق ساحة", "دعم الرحلات الداخلية", "وقود للتوقف الفني"],
    services_en: ["Ramp Coordination", "Domestic Support", "Tech-Stop Fueling"],
  },
  {
    code: "LAQ", icao: "HLLQ", x: 76, y: 22,
    name_ar: "مطار الأبرق الدولي", name_en: "Labraq International Airport",
    city_ar: "البيضاء / الأبرق", city_en: "Al-Bayda / Labraq",
    type_ar: "مركز الشمال الشرقي", type_en: "Northeastern Hub",
    status_ar: "تشغيلي", status_en: "Operational",
    runway: "3,600 m",
    services_ar: ["إشراف جوي", "تصاريح", "مساعدة ركاب"],
    services_en: ["Flight Supervision", "Permits", "Passenger Assist"],
  },
  {
    code: "TOB", icao: "HLTQ", x: 87, y: 32,
    name_ar: "مطار طبرق الدولي", name_en: "Tobruk International Airport",
    city_ar: "طبرق", city_en: "Tobruk",
    type_ar: "الحدود الشرقية", type_en: "Eastern Border Hub",
    status_ar: "تشغيلي", status_en: "Operational",
    runway: "3,000 m",
    services_ar: ["تنسيق ساحة", "تنسيق جمارك وجوازات", "وقود"],
    services_en: ["Ramp Coordination", "Customs Liaison", "Fueling"],
  },
  {
    code: "KFR", icao: "HLKF", x: 80, y: 80,
    name_ar: "مطار الكفرة", name_en: "Kufra Airport",
    city_ar: "الكفرة", city_en: "Kufra",
    type_ar: "الجنوب الشرقي", type_en: "Southeastern Outpost",
    status_ar: "رحلات خاصة", status_en: "Special Flights",
    runway: "3,650 m",
    services_ar: ["إشراف شحن ومهام خاصة", "توقفات فنية"],
    services_en: ["Cargo Supervision", "Technical Stops"],
  },
  {
    code: "TIP", icao: "HLLT", x: 25, y: 35,
    name_ar: "مطار طرابلس الدولي", name_en: "Tripoli International Airport",
    city_ar: "قصر بن غشير — طرابلس", city_en: "Tripoli",
    type_ar: "قيد التطوير", type_en: "Under Redevelopment",
    status_ar: "إعادة افتتاح قريباً", status_en: "Projected Reopening",
    runway: "3,600 m",
    services_ar: ["جاهزية وتخطيط للمناولة"],
    services_en: ["Planning & Ready Handling"],
  },
];

export const STATS = [
  { id: "airports", value: 8, suffix: "+", label_ar: "مطارات ليبية مغطاة بالكامل", label_en: "Libyan Airports Fully Serviced", detail_ar: "معيتيقة، بنينا، مصراتة، سبها، الأبرق، طبرق، الكفرة", detail_en: "Mitiga, Benina, Misrata, Sebha, Labraq, Tobruk & Kufra" },
  { id: "flights", value: 14500, suffix: "+", label_ar: "رحلة ومهمة طيران تمت إدارتها", label_en: "Flights & Missions Handled", detail_ar: "تجارية، شحن جوي، إسعاف طائر وطيران خاص", detail_en: "Commercial, Cargo, Medevac & Executive Flights" },
  { id: "otp", value: 99.4, suffix: "%", decimals: 1, label_ar: "معدل الدقة في المواعيد (OTP)", label_en: "On-Time Dispatch Performance", detail_ar: "التزام صارم بمعايير المناولة الدولية", detail_en: "Strict SLA and turnaround punctuality" },
  { id: "occ", static: "24/7", label_ar: "مركز مراقبة العمليات (OCC)", label_en: "Operations Control Center", detail_ar: "تصاريح ومتابعة جوية فورية", detail_en: "Instant FIR clearance & flight watch" },
];

export const SERVICES = [
  {
    id: "ground_handling", icon: "PlaneTakeoff", badge: "IATA SGHA", span: "lg:col-span-4", image: "ground",
    title_ar: "المناولة الأرضية المتكاملة", title_en: "Comprehensive Ground & Ramp Handling",
    desc_ar: "معدات دعم أرضي كاملة (GSE)، جر ومارشال، وحدات طاقة أرضية GPU/ASU، سلالم ركاب، وخدمات مياه وصرف لجميع طرازات الطائرات.",
    desc_en: "Full GSE, pushback & marshaling, GPU/ASU ground power, passenger stairs and water/toilet service for all aircraft types.",
    bullets_ar: ["توجيه وجر الطائرات (Pushback & Marshaling)", "وحدات طاقة 400Hz ووحدات بدء هوائي", "مناولة أمتعة سريعة وآمنة"],
    bullets_en: ["Aircraft pushback, towing & marshaling", "400Hz GPU & Air Start units", "Priority baggage transfer & security"],
  },
  {
    id: "permits", icon: "FileCheck2", badge: "LYCAA Direct", span: "lg:col-span-2",
    title_ar: "تصاريح الهبوط والعبور", title_en: "Overflight & Landing Permits",
    desc_ar: "إصدار سريع لتصاريح العبور والهبوط في إقليم طرابلس (Tripoli FIR) للرحلات التجارية والدبلوماسية والإسعاف والشحن.",
    desc_en: "Expedited Libyan FIR overflight & landing clearances via direct LYCAA channels for commercial, diplomatic, medevac & cargo flights.",
    bullets_ar: ["عبور المجال الجوي الليبي", "هبوط وتوقف فني بكل المطارات", "تنسيق خانات الهبوط (Slots)"],
    bullets_en: ["Libyan FIR overflight clearances", "Landing & tech-stop permits", "Slot allocation & ATC liaison"],
  },
  {
    id: "fuel_catering", icon: "Fuel", badge: "Jet A-1", span: "lg:col-span-2", image: "catering",
    title_ar: "الوقود والتموين الجوي", title_en: "Jet A-1 Fueling & Catering",
    desc_ar: "تزويد موثوق بوقود Jet A-1 بأسعار تنافسية في كل المطارات، مع تموين جوي فاخر لرحلات VIP وأطقم الطائرات.",
    desc_en: "Guaranteed on-time Jet A-1 uplift at competitive rates across all stations, plus five-star VIP and crew catering.",
    bullets_ar: ["تزويد مباشر Jet A-1 معتمد", "قوائم تموين فاخرة لكبار الشخصيات", "اعتمادات وقود للمشغلين الدوليين"],
    bullets_en: ["Into-plane Jet A-1 delivery", "Bespoke VIP catering menus", "International fuel credit facilities"],
  },
  {
    id: "supervision", icon: "Radio", badge: "OCC 24/7", span: "lg:col-span-4", image: "hero",
    title_ar: "الإشراف والمتابعة الجوية", title_en: "24/7 Flight Supervision & Dispatch",
    desc_ar: "مركز عمليات يراقب رحلاتكم من الإقلاع إلى الهبوط: تنسيق مباشر مع أبراج المراقبة، حزم طقس METAR/TAF، وممثلون ميدانيون عند كل حركة.",
    desc_en: "Round-the-clock flight watch with live ATC liaison, METAR/TAF briefing packages, and station managers attending every movement.",
    bullets_ar: ["مركز عمليات 24/7/365", "رسائل حركة فورية (MVT)", "تخليص جمركي وجوازات سريع CIQ"],
    bullets_en: ["24/7/365 Operations Control Center", "Real-time movement (MVT) messages", "Fast-track CIQ assistance"],
  },
  {
    id: "vip", icon: "Crown", badge: "VIP", span: "lg:col-span-3", image: "vip",
    title_ar: "الطيران الخاص وكبار الشخصيات", title_en: "Executive VIP & Diplomatic Handling",
    desc_ar: "استقبال رسمي عند سلم الطائرة، صالات كبار الشخصيات في معيتيقة وبنينا، مواكبة بسيارات فاخرة، وخصوصية تامة للوفود.",
    desc_en: "Red-carpet tarmac reception, VIP lounges at Mitiga & Benina, luxury ramp transfers and absolute discretion for delegations.",
    bullets_ar: ["صالة VIP بمطار معيتيقة", "ليموزين مباشرة إلى الطائرة", "حجوزات فندقية وأمنية للأطقم"],
    bullets_en: ["VIP lounge access at MJI", "Ramp limousine to aircraft stairs", "5-star crew accommodation"],
  },
  {
    id: "cargo", icon: "Boxes", badge: "DGR Certified", span: "lg:col-span-3", image: "cargo",
    title_ar: "الشحن الجوي والإسعاف الطائر", title_en: "Cargo Logistics & Medevac Support",
    desc_ar: "مناولة طائرات الشحن العريضة، رافعات تحميل رئيسية، شحنات خطرة (DGR)، وتجهيز عاجل لمهام الإسعاف الطائر مع دخول الإسعاف للساحة.",
    desc_en: "Freighter turnarounds with main-deck loaders, DGR handling, and priority medevac coordination with direct tarmac ambulance access.",
    bullets_ar: ["رافعات High-loader للبدن العريض", "دخول إسعاف مباشر بجانب الطائرة", "لوجستيات قطاع النفط والغاز"],
    bullets_en: ["Widebody high-loader capability", "Direct tarmac ambulance access", "Oil & gas spares logistics"],
  },
];

export const MARQUEE = {
  ar: ["مركز عمليات 24/7 بمطار معيتيقة الدولي (MJI)", "تصاريح هبوط وعبور فورية للأجواء الليبية", "تزويد وقود Jet A-1 بجميع المطارات", "مناولة طائرات الشحن والإسعاف الجوي", "امتثال تام لمعايير IATA و ICAO", "تغطية بنغازي ومصراتة وسبها والأبرق وطبرق"],
  en: ["24/7 OCC at Mitiga International Airport (MJI)", "Instant Libyan FIR Overflight & Landing Clearances", "Jet A-1 Fuel Uplift Across All Stations", "Freighter Turnaround & Rapid Medevac Access", "Full ICAO & IATA SGHA Compliance", "Covering Tripoli, Benghazi, Misrata, Sebha & Tobruk"],
};

export const PILLARS = [
  { title_ar: "تواجد ميداني حقيقي", title_en: "True Ground Presence", desc_ar: "فرق ومعدات في مطار معيتيقة وممثلو عمليات في كافة المطارات الليبية.", desc_en: "Physical teams at Mitiga HQ and trusted dispatchers across every Libyan field." },
  { title_ar: "امتثال دولي تام", title_en: "Global Compliance", desc_ar: "تطبيق دقيق لمعايير ICAO ودليل المناولة الأرضية IATA AHM.", desc_en: "Strict alignment with ICAO Annex 6/14 and the IATA Airport Handling Manual." },
  { title_ar: "قناة مباشرة مع الطيران المدني", title_en: "Direct LYCAA Channel", desc_ar: "تواصل مباشر مع مصلحة الطيران المدني لاستخراج التصاريح في وقت قياسي.", desc_en: "Direct coordination with the Libyan CAA for record-time clearances." },
  { title_ar: "شفافية مالية وائتمان", title_en: "Transparency & Credit", desc_ar: "فواتير مفصلة بالعملات الدولية واعتمادات وقود موثوقة للمشغلين.", desc_en: "Itemized multi-currency billing and dependable fuel credit facilities." },
];

export const COMPLIANCE = ["ICAO Annex 6 & 14", "IATA SGHA 2023", "ISAGO Alignment", "LYCAA Certified"];

IMAGES.rahalty_dash = { local: "/assets/img/rahalty-dash.png", fallback: IMAGES.apron.fallback };
IMAGES.rahalty_flight = { local: "/assets/img/rahalty-flight.png", fallback: IMAGES.hero.fallback };
IMAGES.rahalty_mobile = { local: "/assets/img/rahalty-mobile.png", fallback: IMAGES.ground.fallback };

export const RAHALTY_PAGE = {
  hero_badge: { ar: "منظومة تقنية من تطوير شركة العالم", en: "A proprietary platform developed by WAS" },
  hero_title: { ar: "رحلتي — كل ما يتعلق بالرحلة، في نظام واحد", en: "Rahalty — Everything About the Flight, in One System" },
  hero_sub: {
    ar: "نظام متكامل لإدارة العمليات الأرضية والجوية وتوثيق كل تفاصيل الرحلة لحظة بلحظة — من إصدار التصريح حتى إقفال ملف الرحلة.",
    en: "An integrated system for ground & flight operations management, documenting every flight detail moment by moment — from permit issuance to flight-file closure.",
  },
  hero_cta: { ar: "اطلب اشتراكًا تجريبيًا", en: "Request a Trial" },
  shots_eyebrow: { ar: "جولة داخل النظام", en: "Inside the System" },
  shots_note: { ar: "(تصورات تعريفية للواجهات)", en: "(Illustrative interface concepts)" },
  features_eyebrow: { ar: "القدرات", en: "Capabilities" },
  features_title: { ar: "منظومة عمليات متكاملة", en: "A Complete Operations Ecosystem" },
  features: [
    { icon: "ClipboardList", title_ar: "إدارة العمليات الأرضية", title_en: "Ground Ops Management", desc_ar: "قوائم مهام رقمية لكل مناولة، إسناد المعدات والفرق، وتتبع الإنجاز لحظيًا من ساحة الوقوف.", desc_en: "Digital turnaround task checklists, GSE & crew assignment, live progress tracking from the ramp." },
    { icon: "Radar", title_ar: "المتابعة الجوية المباشرة", title_en: "Live Flight Watch", desc_ar: "تتبع حالة الرحلة (OUT/OFF/ON/IN) مع تنبيهات فورية لأي تغيير في المواعيد.", desc_en: "Real-time OUT/OFF/ON/IN flight status tracking with instant alerts on any schedule change." },
    { icon: "FileStack", title_ar: "توثيق كامل للرحلة", title_en: "Full Flight Documentation", desc_ar: "أرشفة كل مستند وصورة وتوقيع وطابع زمني في ملف موحد لكل رحلة — جاهز للمراجعة في أي وقت.", desc_en: "Every document, photo, signature and timestamp archived in one unified flight file, audit-ready anytime." },
    { icon: "Users", title_ar: "الفرق والصلاحيات", title_en: "Teams & Permissions", desc_ar: "أدوار مخصصة لمديري المحطات والمشرفين والميدانيين عبر جميع المطارات الليبية.", desc_en: "Dedicated roles for station managers, supervisors and field agents across all Libyan airports." },
    { icon: "BarChart3", title_ar: "تقارير ومؤشرات فورية", title_en: "Instant Reports & KPIs", desc_ar: "تقارير دقة المواعيد (OTP) والالتزام باتفاقيات الخدمة، قابلة للتصدير لكل رحلة أو فترة.", desc_en: "OTP & SLA compliance reporting per flight or period, exportable for airline clients." },
    { icon: "BellRing", title_ar: "تنبيهات ذكية", title_en: "Smart Alerts", desc_ar: "إشعارات فورية عند التأخير أو نقص المستندات أو اكتمال مراحل المناولة.", desc_en: "Instant notifications on delays, missing documents, or completed handling milestones." },
  ],
  shots: [
    { img: "rahalty_dash", cap_ar: "لوحة تحكم العمليات", cap_en: "Operations Dashboard" },
    { img: "rahalty_flight", cap_ar: "بطاقة الرحلة والتوثيق", cap_en: "Flight Card & Documentation" },
    { img: "rahalty_mobile", cap_ar: "تطبيق الميدان", cap_en: "Field Agent App" },
  ],
  trial_title: { ar: "اطلب اشتراكًا تجريبيًا", en: "Request a Trial Subscription" },
  trial_sub: { ar: "لشركات الطيران ومشغلي الطيران الخاص — سيتواصل معكم فريقنا لتفعيل حسابكم التجريبي.", en: "For airlines & private operators — our team will reach out to activate your trial account." },
  f_company: { ar: "اسم الشركة / المشغل *", en: "Company / Operator *" },
  f_name: { ar: "اسم المسؤول *", en: "Contact Person *" },
  f_email: { ar: "البريد الإلكتروني *", en: "Email *" },
  f_phone: { ar: "الهاتف / واتساب", en: "Phone / WhatsApp" },
  f_volume: { ar: "عدد الرحلات الشهرية المتوقع", en: "Expected Monthly Flights" },
  f_notes: { ar: "ملاحظات إضافية", en: "Additional Notes" },
  f_submit: { ar: "إرسال طلب الاشتراك", en: "Submit Trial Request" },
  f_submitting: { ar: "جارٍ الإرسال...", en: "Sending..." },
  f_success: { ar: "تم استلام طلب الاشتراك التجريبي — مرجع", en: "Trial request received — Ref" },
  f_error: { ar: "تعذر الإرسال — راسلنا على ops@world-was.ly", en: "Could not send — email ops@world-was.ly" },
  volumes: { ar: ["أقل من 5 رحلات", "5 – 20 رحلة", "أكثر من 20 رحلة"], en: ["Under 5 flights", "5 – 20 flights", "20+ flights"] },
};
